// Import: Middleware Action & Custom Types
import { ICC_UNLOCKING_CLEAN, ICC_UNLOCKING_CLEAN_ERROR } from '_models/redux/types';

// Action function
export const cleanIccUnlocking = () => async (dispatch) => {
  // Endpoint: Try & Catch

  try {
    dispatch({
      type: ICC_UNLOCKING_CLEAN,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: ICC_UNLOCKING_CLEAN_ERROR,
      payload: [],
    });
  }
};
